import { CircularProgress, Dialog, Stack } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

/**
 * Styled Dialog with visible overflow for decorative elements
 * Allows rocket and stars icons to extend beyond dialog bounds
 */
export const StyledPaymentDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    overflow: 'visible',
  },
}));

/**
 * Main content container for the modal
 * Responsive spacing with centered alignment
 */
export const StyledModalContent = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(4),
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: theme.spacing(8),
  textAlign: 'center',
  position: 'relative',
  maxWidth: theme.spacing(100),

  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(10),
    paddingTop: theme.spacing(16),
  },
}));

/**
 * Wrapper for subtitle and description text
 * Groups related typography elements
 */
export const StyledTextGroup = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
}));

/**
 * Rocket icon positioned above the modal
 * Decorative element extending beyond dialog bounds
 */
export const StyledRocketIcon = styled('div')(() => ({
  position: 'absolute',
  top: 0,
  left: '50%',
  transform: 'translate(-50%, -75%)',
}));

/**
 * Shooting stars icon positioned behind the rocket
 * Background decorative element
 */
export const StyledStarsIcon = styled('div')(() => ({
  position: 'absolute',
  top: 0,
  left: '50%',
  transform: 'translate(-50%, -100%)',
  zIndex: -1,
}));

/**
 * Loading spinner with left margin
 * Displayed inline with button text during loading state
 */
export const StyledLoadingSpinner = styled(CircularProgress)(({ theme }) => ({
  marginLeft: theme.spacing(4),
}));
